module.exports = function() {
  return new Worker(__webpack_public_path__ + "93929c89889b3b838653.worker.js");
};